import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import AddRoleForm from "./roles/templates/AddRoleForm";
import { RoleModel } from "app/services/api/types/roles/models/RoleModel";
import { useEffect, useState } from "react";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  initialRole?: RoleModel;
}

export function CreateEditRoleModal({
  isVisible,
  onClose,
  onSuccess,
  initialRole,
}: Props) {
  const [isEditing, setIsEditing] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(
    initialRole?.display_name ?? "Create new role",
  );

  const handleTitleUpdate = (newTitle: string) => {
    setCurrentTitle(newTitle);
  };

  useEffect(() => {
    if (isVisible) {
      setIsEditing(!!initialRole);
      setCurrentTitle(initialRole?.display_name ?? "Create new role");
    }
  }, [isVisible, initialRole]);

  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      className="w-full max-w-[737px] mx-auto "
      title={currentTitle}
      hasCancelButton
      isEditing={isEditing}
      onTitleUpdate={handleTitleUpdate}
      canEditTitle
    >
      <AddRoleForm
        onClose={onClose}
        onSuccess={onSuccess}
        isEditing={isEditing}
        initialRole={initialRole}
        currentTitle={initialRole ? currentTitle : ""}
      />
    </ReusableModal>
  );
}
